module.exports = __webpack_public_path__ + "img/interior-design.a745bd0d.webp";